import Icon from '../Icon.vue'

Icon.register({
  'link_90': {
    width: 22,
    height: 9,
    paths: [
      {
        d: 'M17.41 7.111h-1.496c-.553 0-1-.397-1-.889 0-.491.447-.889 1-.889h1.436c.91 0 1.65-.797 1.65-1.777 0-.98-.74-1.778-1.65-1.778h-5.7c-.91 0-1.65.797-1.65 1.778 0 .491-.447.888-1 .888-.553 0-1-.397-1-.888C8 1.595 9.637 0 11.65 0h5.76c.023 0 .047 0 .07.003C19.432.069 21 1.637 21 3.556c0 1.918-1.568 3.486-3.52 3.552a.927.927 0 01-.07.003z',
        transform: 'translate(0.999603)'
      },
      {
        d: 'M10.35 8H4.59c-.023 0-.047 0-.07-.003C2.568 7.931 1 6.363 1 4.444 1 2.526 2.568.958 4.52.892a.928.928 0 01.07-.003h1.496c.553 0 1 .397 1 .889 0 .491-.447.889-1 .889H4.65c-.91 0-1.65.797-1.65 1.777 0 .98.74 1.778 1.65 1.778h5.7c.91 0 1.65-.797 1.65-1.778 0-.491.448-.888 1-.888.553 0 1 .397 1 .888C14 6.405 12.364 8 10.35 8z',
        transform: 'translate(0.999603)'
      }
    ]
  }
})
